import store from '@/store';
import { GIFT_TYPE_ONE_OFF, GIFT_TYPE_SUBSCRIPTION } from '@/constants/Gifting';

export default {
    steps: [
        {
            routeName: 'account.gifting.choose-your-gift',
            enabled: true,
            title: 'Choose a gift',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.choose-your-box-type',
            enabled: store.getters['account/getPrimaryProductInGiftingEnabled'],
            title: 'Choose a size',
            type: [
                GIFT_TYPE_ONE_OFF,
            ],
        },
        {
            routeName: 'account.gifting.number-of-deliveries',
            enabled: true,
            title: 'Number of deliveries',
            type: [
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.delivery-address',
            enabled: true,
            title: 'Delivery address',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.freddies-addons',
            enabled: store.getters['account/getGiftingVaseEnabled'],
            title: 'Extras!',
            type: [
                GIFT_TYPE_ONE_OFF,
            ],
        },
        {
            routeName: 'account.gifting.freddies-shop',
            enabled: store.getters['account/getShopInGiftingEnabled'],
            title: 'Extras!',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.delivery-day',
            enabled: true,
            title: 'Delivery date',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.gift-card',
            enabled: true,
            title: 'Personalised card',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.payment',
            enabled: true,
            title: 'Payment details',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
        {
            routeName: 'account.gifting.thank-you',
            enabled: true,
            title: '',
            type: [
                GIFT_TYPE_ONE_OFF,
                GIFT_TYPE_SUBSCRIPTION,
            ],
        },
    ],
};
